import React from 'react';
const noMore = ['No more rebuilding every class and workshop from scratch.', 'No more hours searching scattered books, handouts and videos.', 'No more explaining arc control, angles and settings with words alone.', 'No more students following steps without understanding why.', 'No more booth sessions without clear visual material.', 'No more repeating the same corrections every week.', 'No more assessing welds and skills without clear criteria.', 'No more losing time you could spend actually teaching.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#16191E] relative overflow-hidden" data-id="element-125" data-mp="vurwwwgxxnkd">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-126" data-mp="vtykbevaw3ub">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-white uppercase" data-id="element-127" data-mp="qwq3bhlw25un">
          Next Month You Can Still Be Searching for Welding Teaching Material...
          <br data-id="element-128" data-mp="zxehccba867j" />
          <span className="text-[#FF9A4D]" data-id="element-129" data-mp="zxobmc3d0zj1">
            Or You Can Have a Complete Visual Training System Ready for Your Next Class.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-[#FF9A4D]/60" data-id="element-130" data-mp="2h37weuu3mexi">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-131" data-mp="2m4xakjcmb8pt">
              <span className="text-[#E8590C] mt-0.5" aria-hidden="true" data-id="element-132" data-mp="2r2ypqt6xanw0">
                ▸
              </span>
              <span className="text-slate-700" data-id="element-133" data-mp="2v2ziliurr1ml">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-134" data-mp="3011224w3x2yl">
          WELDING INSTRUCTOR ATLAS doesn&apos;t replace your own experience, an accredited curriculum,
          official certifications or your institution&apos;s workshop safety training and rules.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-135" data-mp="3esjc7m2ac3a1">
          It supports your teaching with a structured visual system designed to give you more:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-[#FF9A4D]" data-id="element-136" data-mp="1jod0ckl9dbzp">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}